module.exports = __webpack_public_path__ + "static/media/intranet.ed2a24d6.png";